import { get, post, put } from 'aws-amplify/api';
import {getErrorMessage} from "../stores/StoreUtilities";
import Logger from "../components/Logger";
import config from 'react-global-configuration';

export interface ISubscriber {
  email?: string
  first_name?: string,
  last_name?: string,
  tags?: string[]
}

export enum ConvertKitTag {
  Cancellation = "1943537",
  Downgrade = "2713917",
  FreeTrial = "1943533",
  FreeSubscription = "2707228",
  PremiumSubscription = "1943316",
  LifetimeSubscription = "3823661",
  BookAdvisor = "3629559",
  Migrated = "5093627"
}

class ConvertKitAPI {
  private formId = "1762127"
  private enabled: boolean = true

  constructor () {
    this.enabled = config.get("convertKit.enabled")
  }

  addSubscriber = async (subscriber: ISubscriber)=> {
    console.log(`ConvertKitAPI.addSubscriber(${subscriber.email})`)
    if (!this.enabled) {
      console.log(`ConvertKit is not enabled`)
      return "Convert is not enabled"
    }

    try {
      const init = {
        body: {
          ...subscriber
        }
      }
      console.log(`ConvertKit.addSubscriber(${this.formId})`, subscriber)
      const restOperation = post({ apiName: "ConvertKitAPI", path: `/forms/${this.formId}/subscribe`, options: { body: init.body as any } })
      const { body: responseBody } = await restOperation.response
      const response = await responseBody.json() as any
      // const response = await API.post("ConvertKitAPI", `/subscribe/${this.formId}`, init)
      return response
    } catch (err) {
      const message = getErrorMessage(err)
      Logger.error("ConvertKitAPI.addSubscriber error", message)
      throw new Error(message)
    }
  }

  addTag = async (tagId: string, email: string)=> {
    console.log(`ConvertKitAPI.addTag(${tagId}), ${email}`)
    if (!this.enabled) {
      console.log(`ConvertKit is not enabled`)
      return "ConvertKit is not enabled"
    }

    try {
      const init = {
        body: {
          email: email
        }
      }
      const restOperation = post({ apiName: "ConvertKitAPI", path: `/tags/${tagId}/subscribe`, options: { body: init.body as any } })
      const { body: responseBody } = await restOperation.response
      const response = await responseBody.json() as any
      console.log(`ConvertKit tag added`, JSON.stringify(response))
      return response
    } catch (err) {
      const message = getErrorMessage(err)
      Logger.error("ConvertKitAPI.addTag error", message)
      throw new Error(message)
    }
  }

  getSubscriber = async (email: string) => {
    if (!this.enabled) {
      return "Convert is not enabled"
    }

    try {
      const restOperation = get({ apiName: "ConvertKitAPI", path: `/subscribers/${email}` })
      const { body } = await restOperation.response
      const response = await body.json() as any
      return response
    } catch (err) {
      const message = getErrorMessage(err)
      Logger.error("ConvertKitAPI.getSubscriber error", message)
      throw new Error(message)
    }
  }

  putSubscriber = async (subscriberId: string, update: ISubscriber) => {
    if (!this.enabled) {
      return "Convert is not enabled"
    }

    try {
      const init = {
        body: {
          first_name: update.first_name,
          email_address: update.email,
          fields: {
            last_name: update.last_name
          }
        }
      }
      const restOperation = put({ apiName: "ConvertKitAPI", path: `/subscribers/${subscriberId}`, options: { body: init.body as any } })
      const { body: responseBody } = await restOperation.response
      const response = await responseBody.json() as any
      return response
    } catch (err) {
      const message = getErrorMessage(err)
      Logger.error("ConvertKitAPI.updateSubscriber error", message)
      throw new Error(message)
    }
  }

}

export default ConvertKitAPI